'use strict';

module.exports = require('./Slider');


/*****************
 ** WEBPACK FOOTER
 ** ./~/.5.2.1@rc-slider/lib/index.js
 ** module id = 535
 ** module chunks = 0
 **/